import React, { useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from './AppContext';

const ArtistsScreen = () => {
  const navigate = useNavigate();
  const { currentUser, library, purchasedMedia, assetsSummary, userWallet,
    allSingles, allAlbums
   } = useContext(AppContext);

  const artists = useMemo(() => {
    if (!currentUser) {
      console.log('No current user data available.');
      return [];
    }
  
    const ownedIds = new Set(userWallet?.ownedDats?.map(item => item.id) || []);
  
    // 1️⃣ From DATS (owned assets)
    let datsArtists = [];
    if (assetsSummary && ownedIds.size > 0) {
      datsArtists = assetsSummary
        .filter(asset => ownedIds.has(asset.id))
        .map(asset => asset.ArtistName)
        .filter(Boolean);
    }
  
    // 2️⃣ From library items
    if (library && assetsSummary) {
      const existing = new Set(datsArtists);
      for (const libItem of library) {
        const asset = assetsSummary.find(a => a.id === libItem.contentId) || libItem;
        if (asset.ArtistName && !existing.has(asset.ArtistName)) {
          existing.add(asset.ArtistName);
          datsArtists.push(asset.ArtistName);
        }
      }
    }
  
    // Remove duplicates & sort
    const uniqueArtists = Array.from(new Set(datsArtists)).sort();
  
    // 3️⃣ Should we include your own artist name?
    const myName = currentUser?.artistName;
    const hasOwn =
      // any owned DATS by you?
      (assetsSummary &&
        assetsSummary.some(a => ownedIds.has(a.id) && a.ArtistName === myName)) ||
      // any singles by you?
      allSingles?.some(s => s.ArtistName === myName) ||
      // any albums by you?
      allAlbums?.some(a => a.ArtistName === myName);
  
    if (hasOwn && !uniqueArtists.includes(myName)) {
      uniqueArtists.push(myName);
    }
  
    return uniqueArtists;
  }, [assetsSummary, userWallet, currentUser, library, allSingles, allAlbums]);

  const handleSelectArtist = (artist) => {
    navigate('/library/artists/artistsmedialist', { state: { artist } });
  };

  return (
    <div style={styles.fullScreen}>
      <img src={require('./assets/BlankBG.png')} style={styles.fullScreenImage} alt="Background" />
      <div style={styles.container}>
        <div style={styles.headerContainer}>
          <h2 style={styles.headerText}>Artists</h2>
        </div>
        <ul style={styles.scrollContainer}>
          {artists.map((artist, index) => (
            <li key={`artist-${index}`} style={styles.listItem}>
              <button onClick={() => handleSelectArtist(artist)} style={styles.button}>
                <div style={styles.row}>
                  <img src={require('./assets/dot.png')} alt="Dot" style={{ width: '2vh', height: '2vh', marginRight: '1vw' }} />
                  <span style={styles.text}>{artist}</span>
                </div>
              </button>
              <div style={styles.borderContainer}>
                <div style={styles.centeredBorder}></div>
              </div>
            </li>
          ))}
        </ul>
        <div style={styles.extraSpace}></div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    justifyContent: 'center',
alignItems: 'flex-start',
    backgroundColor: 'transparent',
    zIndex: 10,
    height: `calc(100vh - 18vh)`,
  },
  extraSpace: {
    height: '300px',
      },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  fullScreen: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
alignItems: 'flex-start',

    position: 'relative',
  },
  fullScreenImage: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    zIndex: 0,
  },
  button: {
    backgroundColor: 'transparent',
    border: 'none',
    padding: '1vh',
    margin: '1vh 0',
    cursor: 'pointer',
    zIndex: 10,
    textAlign: 'left',
    width: '100%',
  },
  text: {
    color: 'white',
    fontSize: '2.4vh',
    fontWeight: 'bold',
    fontFamily: 'brhendrix',
  },
  scrollContainer: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    position: 'relative', // Changed from 'absolute' to 'relative'
    width: '100%',
    height: '130%',
    zIndex: 2,
    overflowY: 'auto',
    overflowX: 'hidden',
    marginLeft: '20px',

  },
  borderContainer: {
    width: '100%',
alignItems: 'flex-start',
    marginTop: '0',
  },
  centeredBorder: {
marginLeft: '20px',

    width: '110%',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'rgba(189, 252, 251, 0.3)',
  },
  headerContainer: {
    display: 'flex',
    marginLeft: '30px',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '1vh 0', // Add padding to the header container
    width: '100%',
    backgroundColor: 'transparent', // Ensure the background is transparent
    zIndex: 10,
  },
  headerText: {
    color: 'white',
    fontSize: '2.5vh',
    fontWeight: 'bold',
    textAlign: 'center', // Center the text horizontally
    fontFamily: 'brhendrix',
  },
  listItem: {

  },
  image: {
    width: '2vh',
    height: '2vh',
    marginRight: '10px',
    resizeMode: 'contain',
  },
};

export default ArtistsScreen;
